import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { dashboardZone, zoneWidgets } from "../../../api";
import {
  setDashboardZone,
  setDashboardDetails,
  setZoneWidgets,
} from "../../../redux";
import { UserInfo } from "../UserInfo";
import { Notification } from "../Notification";
import { Widget } from "../../../shared";
import { Row, Col } from "reactstrap";
import { ModalComp, Add } from "../../../shared";
import { Options } from "./Options";
import { withRouter } from "react-router-dom";
import { FiShield, FiChevronDown, FiHelpCircle } from "react-icons/fi";
import { AutoOrSen } from "../AutoOrsen";
import { useTranslation } from "react-i18next";

const MainPageDesktopComp = (props) => {
  const { t } = useTranslation();
  const { today } = props;
  const dispatch = useDispatch();
  const token = Cookies.get("token");
  const dashboardMine = useSelector(
    (state) => state.dashboardMine.dashboardMine
  );
  const [showDashboard, setShowDashboard] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [showOptions, setShowOptions] = useState(false);
  const [isShow, setIsShow] = useState(true);
  let [activeIndex, setActiveIndex] = useState(0);

  const toggle = () => setOpenModal(!openModal);
  const toggleOptions = () => setShowOptions(!showOptions);
  const openDash = (value) => setShowDashboard(value);
  const showScenarios = () => setIsShow(!isShow);

  const getGreetingTime = () => {
    const h = new Date().getHours();
    if (h < 12) return t("صبح بخیر");
    if (h < 18) return t("عصر بخیر");
    return t("شب بخیر");
  };

  const getGreetingIcon = () => {
    const h = new Date().getHours();
    if (h < 12) return "🌤";
    if (h < 18) return "☀️";
    return "🌙";
  };

  const dashboardDetail = (value, index) => {
    setActiveIndex(index);
    const formData = new FormData();
    formData.append("dashboard", value.id);
    dashboardZone(formData, token)
      .then((res) => {
        dispatch(setDashboardDetails(value));
        dispatch(setDashboardZone(res.data.data));
        const zoneId = new FormData();
        zoneId.append("zone", res.data.data[0]["id"]);
        zoneWidgets(zoneId, token)
          .then((res) => dispatch(setZoneWidgets(res.data.data)))
          .catch(() => dispatch(setZoneWidgets([])));
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  return (
    <React.Fragment>
      <ModalComp modal={openModal} toggle={toggle} component={<Add />} />
      <div className="desktop-panel">

        {/* ════ بخش بالا ════ */}
        <div className="desktop-top-section">

          <div className="desktop-topstrip">
            <div className="desktop-topstrip-left">
              <UserInfo />
            </div>
            <div className="desktop-topstrip-center">
              <Notification
                openDash={openDash}
                toggleOptions={toggleOptions}
                showOptions={showOptions}
              />
            </div>
            <div className="desktop-topstrip-right">

              <button className="desktop-security-btn" title={t("سیستم امنیتی")}>
                <FiShield size={18} />
                <span className="desktop-security-label">{t("امنیت")}</span>
              </button>
            </div>
          </div>

{showDashboard && (
  <div className="desktop-dashboard-row">
    {dashboardMine?.map((dash, index) => (
      <span
        key={index}
        className={`desktop-dash-chip cursor ${activeIndex === index ? "active" : ""}`}
        onClick={() => dashboardDetail(dash, index)}
      >
        {dash.dashboard_caption}
      </span>
    ))}
    <span className="desktop-dash-chip add-chip cursor" onClick={toggle}>
      +
    </span>
  </div>
)}

          {!showOptions ? (
            <>
              <div className="desktop-greeting-row">
                {/* <div className="desktop-widget-area">
                  <Widget today={today} />
                </div> */}
                <div className="desktop-greeting-block">
                  <span className="desktop-greeting-emoji">{getGreetingIcon()}</span>
                  <div className="desktop-greeting-text">
                    <p className="desktop-greeting-title">{getGreetingTime()}</p>
                    <p className="desktop-greeting-date">{today}</p>
                  </div>
                </div>
              </div>

              <div className="desktop-scenarios-wrap">
                {isShow && <AutoOrSen />}
              </div>
            </>
          ) : (
            <Options toggleOptions={toggleOptions} toggle={toggle} />
          )}

          <div className="desktop-collapse-handle cursor" onClick={showScenarios}>
            <FiChevronDown
              size={16}
              style={{
                transform: isShow ? "rotate(180deg)" : "rotate(0deg)",
                transition: "transform 0.2s ease",
              }}
            />
          </div>
        </div>

        {/* ════ بخش پایین: دستگاه‌ها ════ */}
        <div className="desktop-bottom-section">
          {props.children}
        </div>

      </div>
    </React.Fragment>
  );

};

const MainPageDesktop = withRouter(MainPageDesktopComp);
export { MainPageDesktop };
